import { HourFormat, WeekDay } from '@mews/enums';
import { DateLocalization, TimeLocalization } from '../services';

export const getDefaultLocalization = () =>
    ({
        cultureCode: 'en-US',
        weekStart: WeekDay.Monday,
        timeShortFormat: 'h:mm a',
        timeFormat: 'h:mm:ss a',
        dateFormat: 'MM/dd/yyyy',
        dateShortFormat: 'M/d',
        dateShortMonthDayFormat: 'MMM d',
        dateLongFormat: 'EEEE, MMMM d, yyyy',
        dateTimeFormat: 'EEEE, MMMM d, yyyy h:mm:ss a',
        anteMeridiem: 'AM',
        postMeridiem: 'PM',
        hourFormat: HourFormat.Twelve,
        dayShortNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
        monthShortNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    }) as const satisfies DateLocalization & TimeLocalization;
